var Load = (function() {
    var t = {};
    t.data = null;

    t.events = function() {
        $('.load-more a').click(function(e) {
            e.preventDefault();

            var href = $(this).attr('href');
            t.data = $(this).data();

            $.get(href, t.parseResult);
            
            
        });
    };

    t.parseResult = function(result) {
        var html = $.parseHTML(result);

        var elements = $(t.data.element, html);
        //t.data.destination is a reference to .news-tile-list
        //elements holds are newly loaded list items
        //this function is appending the new elements onto our list
        $(t.data.destination).append(elements);

        var button = $(html).find('.load-more');

        if(button.length) {
            $('.load-more a').attr('href', button.children('a').attr('href'));
        } else {
            $('.load-more').hide();
        }
        // elements.forEach(el => {

        // })        
        var newElements = $('.news-tile')
        window.App.grids[0].items = [...newElements]
        // window.App.grids.gap = 0
        // window.App.grids[0].ncol = 0 //Reset our number of columns.  This way when we trigger layout it should run properly.
        // window.App.grids[0].ncol = 0

        console.log('results loaded')
        setTimeout(() => {
            window.App.grids.layout()
        }, 500)
    }

    t.init = function() {
        t.events();

    };
    return t;
})();
